import React, { Component } from "react";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import ThemeableAgGrid from "../../common/components/agGrid/ThemeableAgGrid";
import QualityAttributeBadges from "../common/qualityAttributeBadges";
import OrderCell from "../common/orderCell";
import { formatDateTime } from "../../common/services/utilities";
import { withTranslation } from "react-i18next";

class OrganizationOrders extends Component {
  columnDefs = [
    {
      name: "orderId",
      field: "orderId",
      headerName: this.props.t("OrderId"),
      flex: 3,
    },
    {
      name: "marketName",
      field: "marketName",
      headerName: this.props.t("MarketName"),
      flex: 2,
    },
    {
      name: "termName",
      field: "termName",
      headerName: this.props.t("TermName"),
      flex: 1.5,
    },
    {
      name: "qualityAttributeValues",
      headerName: this.props.t("QualityAttributes"),
      flex: 1.5,
      content: (params) => (
        <QualityAttributeBadges
          qualityAttributeValues={params.data?.qualityAttributeValues}
        />
      ),
    },
    {
      name: "orderDate",
      headerName: this.props.t("OrderDate"),
      flex: 1.5,
      cellRenderer: (params) => {
        return (
          <span>
            {formatDateTime(
              params.data?.orderDate,
              Intl.DateTimeFormat().resolvedOptions().timeZone,
              " ",
            )}
          </span>
        );
      },
    },
    { name: "orderState", headerName: this.props.t("OrderState"), flex: 1 },
    {
      name: "allOrNone",
      headerName: this.props.t("AllOrNone"),
      flex: 1,
      cellRenderer: (params) => {
        return params.data?.allOrNone ? (
          <FontAwesomeIcon icon={faCheck} />
        ) : null;
      },
    },
    // {name: 'volume', headerName: this.props.t("Volume")},
    {
      name: "price",
      headerName: this.props.t("Price"),
      flex: 1,
      cellRenderer: (params) => {
        return (
          <OrderCell
            value={params.data?.price}
            type={params.data?.orderDirection === "Buy" ? "Bid" : "Offer"}
            isDepth={false}
            pricePrecision={params.data?.pricePrecision}
            data={params.data}
            instrumentId={params.data?.instrumentId}
            orderId={params.data?.orderId}
            price={params.data?.price}
            volume={params.data?.volume}
            volumePrecision={params.data?.volumePrecision}
            uomName={params.data?.uomName}
            currencyName={params.data?.currencyName}
            currencySymbol={params.data?.currencySymbol}
            modifyOrder={this.props.modifyOrder}
            withdrawOrder={this.props.withdrawOrder}
            align={false}
            isOrganizationOrder={true}
            isUserOrder={true}
            displayMode="marketGridBadge"
            contentType="price"
          />
        );
      },
    },
    {
      name: "volume",
      headerName: this.props.t("Volume"),
      flex: 1,
      cellRenderer: (params) => {
        return (
          <OrderCell
            value={params.data?.volume}
            type={params.data?.orderDirection === "Buy" ? "Bid" : "Offer"}
            isDepth={false}
            pricePrecision={params.data?.pricePrecision}
            data={params.data}
            instrumentId={params.data?.instrumentId}
            orderId={params.data?.orderId}
            price={params.data?.price}
            volume={params.data?.volume}
            volumePrecision={params.data?.volumePrecision}
            uomName={params.data?.uomName}
            currencyName={params.data?.currencyName}
            currencySymbol={params.data?.currencySymbol}
            modifyOrder={this.props.modifyOrder}
            withdrawOrder={this.props.withdrawOrder}
            align={false}
            isOrganizationOrder={true}
            isUserOrder={true}
            displayMode="marketGridBadge"
            contentType="volume"
          />
        );
      },
    },
  ];

  render() {
    const { organizationOrders } = this.props;
    const data = _.orderBy(organizationOrders, "orderDate", "desc");

    return (
      <ThemeableAgGrid
        className="table table-dark table-small trading-grid"
        columnDefs={this.columnDefs}
        rowData={data}
        animateRows={true}
        domLayout="autoHeight"
        getRowHeight={() => 24}
        rowSelection={false}
      />
    );
  }
}

export default withTranslation(["trading"])(OrganizationOrders);

